const DevMode: boolean = false;

const GatewayUrl: string = DevMode
  ? "http://localhost/Lernzeitkonto/lzk-participant-gateway/api.php"
  : "https://lernzeitkonto.wbstraining.de/lzk-gateway-extern/api.php";

export default GatewayUrl;
